import { __assign } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import { VideoPopupLink } from '../VideoPopupLink/VideoPopupLink.esm.js';
import { AddToCart } from '@invitae/add-to-cart';
import { useCountryLocationPrefix } from '@invitae/nucleobase-engine-contentful';
import { useGlobalActions } from '../../hooks/useGlobalActions.esm.js';
import styles from './BaseLink.module.esm.js';

var linkAttr = function (_a) {
    var url = _a.url, path = _a.path, prCode = _a.prCode, type = _a.type, addCountryCodePrefix = _a.addCountryCodePrefix;
    switch (type) {
        case 'externalLink':
            return {
                href: url,
                rel: 'noreferrer noopener',
                target: '_blank',
            };
        case 'patientTestLink':
            return {
                href: addCountryCodePrefix("/patients/order?test_code=".concat(prCode)),
                target: '_self',
            };
        case 'internalLink':
            return {
                href: addCountryCodePrefix(path),
                target: '_self',
            };
    }
};
var BaseLink = function (_a) {
    var rootElementProps = _a.rootElementProps, classes = _a.classes, children = _a.children, fields = _a.fields, onLoad = _a.onLoad, eventProps = _a.eventProps, Element = _a.element;
    var addCountryCodePrefix = useCountryLocationPrefix().addCountryCodePrefix;
    var dispatchAction = useGlobalActions().dispatchAction;
    React.useEffect(function () {
        // on load callback is used when BaseLink is wrapping a component so that we render the parent component
        // when the loading is completed to avoid jitter
        if (onLoad)
            onLoad();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Patient Test Link
    if (fields.prCode) {
        var prCodeWithoutWhitespaces = fields.prCode.replace(/\s/g, '');
        return (React.createElement(AddToCart, __assign({ className: classes === null || classes === void 0 ? void 0 : classes.root, element: "a", productId: prCodeWithoutWhitespaces }, linkAttr({ addCountryCodePrefix: addCountryCodePrefix, prCode: prCodeWithoutWhitespaces, type: 'patientTestLink' }), rootElementProps), children));
    }
    // External Link
    if ('url' in fields) {
        return (React.createElement("a", __assign({ className: classes === null || classes === void 0 ? void 0 : classes.root }, linkAttr({
            addCountryCodePrefix: addCountryCodePrefix,
            type: 'externalLink',
            url: fields.url,
        }), rootElementProps), children));
    }
    if ('vimeoId' in fields) {
        return (React.createElement(VideoPopupLink, __assign({ classes: classes === null || classes === void 0 ? void 0 : classes.root, vimeoId: fields.vimeoId }, rootElementProps), children));
    }
    if ('actionName' in fields) {
        var actionProps = __assign(__assign({}, rootElementProps), { className: classNames(styles.actionElement, classes === null || classes === void 0 ? void 0 : classes.root), onClick: function () { return dispatchAction(fields.actionName, eventProps); } });
        if (Element) {
            return React.createElement(Element, __assign({}, actionProps), children);
        }
        return (React.createElement("button", __assign({ type: "button" }, actionProps), children));
    }
    // Default - internal link
    return (React.createElement("a", __assign({ className: classes === null || classes === void 0 ? void 0 : classes.root }, linkAttr({
        addCountryCodePrefix: addCountryCodePrefix,
        path: fields.path,
        type: 'internalLink',
    }), rootElementProps), children));
};

export { BaseLink, BaseLink as default };
//# sourceMappingURL=BaseLink.esm.js.map
